/*
 * Annyo · utilidades compartidas de carrito
 * Usado por: Skin Finder y Arma tu ritual.
 * Solo contiene lo común: formato de dinero y agregado múltiple a /cart/add.
 * La actualización visual del carrito la hace el propio componente del theme
 * (<cart-notification> o <cart-drawer>) mediante su método renderContents.
 */
(function () {
  if (window.AnnyoCart) return;

  function group(x, sep) {
    return x.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  // Formatea centavos con el formato de moneda de la tienda (shop.money_format)
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var n = (cents || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      var parts;
      if (k === 'amount_no_decimals') return group(Math.round(n).toString(), ',');
      if (k === 'amount_with_comma_separator') { parts = n.toFixed(2).split('.'); return group(parts[0], '.') + ',' + parts[1]; }
      if (k === 'amount_no_decimals_with_comma_separator') return group(Math.round(n).toString(), '.');
      parts = n.toFixed(2).split('.'); return group(parts[0], ',') + '.' + parts[1];
    });
  }

  function findCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /*
   * Agrega varios productos al carrito real de Shopify en una sola petición.
   * items: [{ id: variantId, quantity: 1 }, ...]
   * source: identificador del componente que agrega (para el evento cartUpdate del theme)
   * Devuelve la respuesta de Shopify, o null si el theme no tiene carrito
   * dinámico y se redirige a /cart. Lanza Error si Shopify rechaza la petición.
   */
  async function addItems(items, source) {
    var cart = findCart();
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    var res = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    var data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || '');
    if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return null; }
    var first = data.items && data.items[0];
    var state = Object.assign({}, data, first ? { key: first.key, id: first.id } : {});
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: source || 'annyo', cartData: data });
    }
    if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    cart.renderContents(state);
    return data;
  }

  window.AnnyoCart = { formatMoney: formatMoney, addItems: addItems };
})();
